var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  experimentTemplateDictionary: {},
  experimentExtensionsDictionary: {}
};
const loadExperimentTemplatesPrefix = "loadExperimentTemplates";
const loadExperimentTemplatesActionTypes = {
  LOAD: `${loadExperimentTemplatesPrefix}/LOAD`,
  LOADING: `${loadExperimentTemplatesPrefix}/LOADING`,
  LOADED: `${loadExperimentTemplatesPrefix}/LOADED`
};
const loadExperimentExtensionsPrefix = "loadExperimentExtensions";
const loadExperimentExtensionActionTypes = {
  LOAD: `${loadExperimentExtensionsPrefix}/LOAD`,
  LOADING: `${loadExperimentExtensionsPrefix}/LOADING`,
  LOADED: `${loadExperimentExtensionsPrefix}/LOADED`
};
const loadExperimentTemplates = (workspaceId, managementGroup) => {
  return {
    type: loadExperimentTemplatesActionTypes.LOAD,
    workspaceId,
    managementGroup
  };
};
const loadingExperimentTemplates = (managementGroup) => {
  return {
    type: loadExperimentTemplatesActionTypes.LOADING,
    managementGroup
  };
};
const loadedExperimentTemplates = (managementGroup, experimentTemplateDataList) => {
  return {
    type: loadExperimentTemplatesActionTypes.LOADED,
    managementGroup,
    templateDataList: experimentTemplateDataList
  };
};
const loadExperimentExtensions = (workspaceId, managementGroup) => {
  return {
    type: loadExperimentExtensionActionTypes.LOAD,
    workspaceId,
    managementGroup
  };
};
const loadingExperimentExtensions = (managementGroup) => {
  return {
    type: loadExperimentExtensionActionTypes.LOADING,
    managementGroup
  };
};
const loadedExperimentExtensions = (managementGroup, experimentExtensions) => {
  return {
    type: loadExperimentExtensionActionTypes.LOADED,
    managementGroup,
    experimentExtensions
  };
};
const experimentTemplateSelectorReducer = (state = defaultReducerState, action) => {
  var _a, _b, _c, _d, _e, _f;
  switch (action.type) {
    case loadExperimentTemplatesActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentTemplateDictionary: __spreadProps(__spreadValues({}, state.experimentTemplateDictionary), {
          [(_a = action.managementGroup) != null ? _a : "unknown"]: {
            isLoading: true,
            data: null,
            error: ""
          }
        })
      });
    case loadExperimentTemplatesActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        experimentTemplateDictionary: __spreadProps(__spreadValues({}, state.experimentTemplateDictionary), {
          [(_b = action.managementGroup) != null ? _b : "unknown"]: (_c = action.templateDataList) != null ? _c : {
            isLoading: false,
            data: null,
            error: `Error loading experiment template for management group : ${action.managementGroup}`
          }
        })
      });
    case loadExperimentExtensionActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentExtensionsDictionary: __spreadProps(__spreadValues({}, state.experimentExtensionsDictionary), {
          [(_d = action.managementGroup) != null ? _d : "unknown"]: {
            status: AsyncRequestStatus.Pending,
            data: null,
            error: ""
          }
        })
      });
    case loadExperimentExtensionActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        experimentExtensionsDictionary: __spreadProps(__spreadValues({}, state.experimentExtensionsDictionary), {
          [(_e = action.managementGroup) != null ? _e : "unknown"]: (_f = action.experimentExtensions) != null ? _f : {
            status: AsyncRequestStatus.Failed,
            data: null,
            error: `Error loading experiment extensions for management group : ${action.managementGroup}`
          }
        })
      });
    default:
      return state;
  }
};
export {
  experimentTemplateSelectorReducer as default,
  defaultReducerState,
  experimentTemplateSelectorReducer,
  loadExperimentExtensionActionTypes,
  loadExperimentExtensions,
  loadExperimentTemplates,
  loadExperimentTemplatesActionTypes,
  loadedExperimentExtensions,
  loadedExperimentTemplates,
  loadingExperimentExtensions,
  loadingExperimentTemplates
};
//# sourceMappingURL=ExperimentTemplateSelector.ducks.js.map
